window.$ = jQuery;

const Underlay = (function() {
    window.sizeUnderlay = function() {
        if ($(".page-heading__bg").length == 0) {
            return;
        }    
        var underlayBottom = $(".page-heading").position().top + $(".page-heading").outerHeight(true);
        $(".page-heading__bg").css("height", underlayBottom + "px");
    }
    
    window.sizeUnderlay();

    $(window).resize(window.sizeUnderlay);
})();

export default Underlay;